import {
  SET_CURRENT_SLIDE_MODE,
  SELECT_NEXT_SLIDE,
  SELECT_PREV_SLIDE,
  SET_CURRENT_ACTIVE_SLIDE,
} from '@/vuex/types'

// actions
import common from '@/vuex/actions/common'
import currentAccount from '@/vuex/actions/currentAccount'
import currentUser from '@/vuex/actions/currentUser'
import errors from '@/vuex/actions/errors'
import folders from '@/vuex/actions/folders'
import numbers from '@/vuex/actions/numbers'
import indicators from '@/vuex/actions/indicators'
import presentations from '@/vuex/actions/presentations'
import selections from '@/vuex/actions/selections'
import syncLoading, { syncStatusOf } from '@/vuex/actions/syncLoading'
import slideActive from '@/vuex/actions/slideActive'
import presentation from '@/vuex/actions/presentation'
import slides from '@/vuex/actions/slides'
import search from '@/vuex/actions/search'
import exportData from '@/vuex/actions/exportData'
import survey from '@/vuex/actions/survey'
import breadcrumbs from '@/vuex/actions/breadcrumbs'
import pricing from '@/vuex/actions/pricing'
import clickedUrl from '@/vuex/actions/clickedUrl'
import modal from '@/vuex/actions/modal'
import hints from '@/vuex/actions/hints'
import googleSlide from '@/vuex/actions/googleSlide'
import everyoneAnswer from '@/vuex/actions/everyoneAnswer'
import counting from '@/vuex/actions/counting'
import powerpoint from '@/vuex/actions/powerpoint'
import quiz from '@/vuex/actions/quiz'
import spinnerWheel from '@/vuex/actions/spinnerWheelActions'
import accountRemoval from '@/vuex/actions/accountRemoval'
import histories from '@/vuex/actions/histories'

export default {
  ...common,
  ...currentAccount,
  ...currentUser,
  ...errors,
  ...folders,
  ...numbers,
  ...indicators,
  ...presentations,
  ...selections,
  ...syncLoading,
  ...slideActive,
  ...presentation,
  ...slides,
  ...histories,
  ...search,
  ...exportData,
  ...survey,
  ...breadcrumbs,
  ...pricing,
  ...clickedUrl,
  ...modal,
  ...hints,
  ...googleSlide,
  ...everyoneAnswer,
  ...counting,
  ...powerpoint,
  ...quiz,
  ...spinnerWheel,
  ...accountRemoval,
  // Config multiple language
  setLang: (context, payload) => {
    context.commit('setLang', payload)
  },
  setPresenterLang: (context, payload) => {
    context.commit('setPresenterLang', payload)
  },
  userAction: () => {},
  routeChangeAction: () => {},
  showToastAction: () => {},
  afterCreateNewPresentationAction: () => {},
  // AHA-47221: the payload is normally the status on its own (1 saving, 2 saved, 3 failed), and
  // still is for almost every caller. It may also arrive as `{ status, from }` — a status plus a
  // label saying which save this is, which subscribers can read off the dispatch (see
  // PptEditorMixin, where the PowerPoint add-in's editor dialog uses it to tell a slide selection
  // apart from an edit).
  //
  // Only the status is committed either way: state.isSyncing is a number that the whole editor
  // compares against 1/2/3, and an object landing in it would break every one of those checks.
  // The label is for whoever is listening to the dispatch, not for the store.
  setSyncPresentation: (context, payload) => {
    context.commit('setSyncPresentation', syncStatusOf(payload))
  },
  setSyncPresentationAction: (context, payload) => {
    context.commit('setSyncPresentation', syncStatusOf(payload))
  },

  [SELECT_NEXT_SLIDE]: ({ dispatch, getters }) => {
    dispatch(SET_CURRENT_ACTIVE_SLIDE, getters.nextSlideId)
  },

  [SELECT_PREV_SLIDE]: ({ dispatch, getters }) => {
    dispatch(SET_CURRENT_ACTIVE_SLIDE, getters.prevSlideId)
  },

  [SET_CURRENT_ACTIVE_SLIDE]: ({ dispatch, state }, id) => {
    const selectedSlide = state.presentation.slides.find((s) => s.id === id)
    dispatch('setSlideActive', selectedSlide)
  },

  [SET_CURRENT_SLIDE_MODE]: ({ commit }, payload) => {
    commit(SET_CURRENT_SLIDE_MODE, payload)
  },
}
